(() => {
  const close = menu => menu.removeAttribute('open');
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.cft-mobile-menu[open]');
    if (menu) {
      close(menu);
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.cft-mobile-menu[open]');
    if (menu && (!menu.contains(event.target) || event.target.closest('a'))) close(menu);
  });
  window.matchMedia('(min-width:1081px)').addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.cft-mobile-menu[open]').forEach(close);
  });
})();
